/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import _ from 'lodash'
//img
import clubInfoBg from '@assets/images/bg/club-portal/club-portal-bg.png'
import clubEmblemAlternateImg from '@assets/images/icon/logo-shield-cool-gray-club.png'
// icon
import { ArrowIco } from '@shared/Icon/ArrowIcon'
import { ClubMessageIco, ClubPortalIco } from '@shared/Icon/ClubIcon'
import { ProfileIco } from '@shared/Icon/HeaderIcon'
// css
import { BadgeStyle } from '@styles/base.style'
import { Button, ButtonWrap, PopupBtnStyle } from '@styles/button.style'
import { ClubSignature } from '@views/Club/index.style'

import { SimpleClubInfoItem } from '@store/clubStore'
import useRootStore from '@store/useRootStore'
// import superiorClubBadgeIco from '@assets/images/icon/club_icon/superior-club-badge-ico.png'
import { Badge } from 'antd-mobile'
import { CLUB_NOTICE_TYPE } from '@constants/index'
import { isMobile } from 'react-device-detect'
import VanillaTilt from 'vanilla-tilt'
import { useOnMount } from '@utils/reactExt'
import { Schema$SimpleClubNotice } from '@interface/common'
import { ClubDetailInfoPopup, NoticeCommonTag } from './index.style'
import ClubNoticePopup from './ClubNoticePopup'

interface ClubInfoPopupProps {
  club: SimpleClubInfoItem
  onCloseClubDetail?: () => void
  onClickMatchup?: (id: string) => void
}

const ClubInfoPopup: React.FC<ClubInfoPopupProps> = (props: ClubInfoPopupProps) => {
  const {
    globalStore,
    clubStore,
    // authStore,
    componentStore,
    userStore,
  } = useRootStore()
  const { club, onCloseClubDetail, onClickMatchup } = props
  const [notices, setNotices] = useState<Schema$SimpleClubNotice[]>([])
  if (!club) {
    if (onCloseClubDetail) {
      onCloseClubDetail()
    }

    return <Fragment/>
  }

  const {
    id,
    name,
    memberCount,
    emblemImageUrl,
    // isRecommendClub,
  } = club

  const { extraClubUnreadMessageCount } = componentStore

  useOnMount(async () => {
    const noticeList = await clubStore.getClubNoticeList(id) ?? []
    setNotices(noticeList)
  })

  const makeBadgeText = () => {
    return _.toString(extraClubUnreadMessageCount).toLocaleString()
  }

  const onClickShowClubMessage = () => {
    componentStore.setExtraClubId(id)
    globalStore.setVisibleMessageBox(true, true)
  }

  const onClickClubNoticePopup = notice => {
    clubStore.setSelectedNotice(notice)
    globalStore.setVisibleClubNoticePopup(true)
    userStore.readClubNotice([notice])
  }

  const clubNoticeListItem = []
  for (const notice of notices) {
    clubNoticeListItem.push(
      <li key={notice.id} className="club-notice--board--item">
        <Button className="club-notice--board--item--btn" onClick={() => onClickClubNoticePopup(notice)}>
          <h3 className="club-notice--board--item--btn--tit">
            {notice.type === CLUB_NOTICE_TYPE.NOTICE && (
              <NoticeCommonTag className="notice-tag">공지사항</NoticeCommonTag>
            )}
            {notice.type === CLUB_NOTICE_TYPE.EVENT && (
              <NoticeCommonTag className="event-tag">이벤트</NoticeCommonTag>
            )}
            {notice.title}
          </h3>
          <p className="club-notice--board--item--btn--contents">
            {notice.contents}
          </p>
        </Button>
      </li>,
    )
  }

  const clubNoticeList = (
    <Fragment>
      {/* 이벤트 공지일 경우 <Button>에 'event-btn'을 추가해주시면 됩니다.*/}
      {clubNoticeListItem.length === 0 && (
        <ul className="club-notice--board">
          {/* 데이터가 없을 경우 */}
          <div className="club-notice--board--item--btn no-data">
            공지사항이 없습니다.
          </div>
        </ul>
      )}

      {notices.length > 0 && (
        <ul className="club-notice--board">
          {clubNoticeListItem}
        </ul>
      )}
    </Fragment>
  )

  const applyDefaultEmblem = e => {
    e.target.src = clubEmblemAlternateImg
  }

  function Tilt(tiltProps) {
    const { options, ...rest } = tiltProps
    const tilt = useRef(null)

    useEffect(() => {
      VanillaTilt.init(tilt.current, options)
    }, [options])

    return <div ref={tilt} {...rest} />
  }

  const emblemOptions = {
    speed: 1000,
    scale: 1.1,
  }
  const options = {
    speed: 1000,
    max: 2,
    glare: true,
    'max-glare': .2,
  }

  const clubTopContents = (
    <ul className="club-notice--info">
      <li className="club-notice--info--member info-group">
        <span className="club-notice--info--member--tit member"><ProfileIco/>회원</span>
        <span className="club-notice--info--member--num">{_.toString(memberCount).toLocaleString()}<span> 명</span></span>
      </li>
      <li className="club-notice--info--message info-group">
        <span className="club-notice--info--message--tit message">
          <ClubMessageIco/>
          {extraClubUnreadMessageCount > 0 && (
            <Badge text={makeBadgeText()} overflowCount={99} css={BadgeStyle} className="badge-style club-info"/>)}
          쪽지
        </span>
        <Button className="club-notice--info--message--btn" onClick={onClickShowClubMessage}>
          <span>쪽지 보기</span><ArrowIco/>
        </Button>
      </li>
    </ul>
  )

  return (
    <Fragment>
      <ClubDetailInfoPopup>
        <div className="club-detail-info-bg-wrap">
          <img src={clubInfoBg} alt="" className="club-detail-info-bg"/>
        </div>
        <ClubSignature className="club-signature club-info">
          {/* 기획 변경으로 주석처리 [이슈링크](https://task.zempublic.co.kr/view.php?id=9798) */}
          {/* 우수 클럽에게만 붙여지는 배지입니다. */}
          {/*{!authStore.isSpecificClubMember && isRecommendClub && (*/}
          {/*  <img src={superiorClubBadgeIco} alt="우수클럽배지" className="badge"/>*/}
          {/*)}*/}
          {isMobile ?
            <div className="img-wrap">
              <img src={emblemImageUrl} onError={applyDefaultEmblem} alt="클럽 엠블럼"
                   className={emblemImageUrl ? 'emblem' : 'emblem alternate-emblem'}/>
            </div>
            :
            <Tilt className="emblem-tilt" options={emblemOptions}>
              <div className="img-wrap">
                <img src={emblemImageUrl} onError={applyDefaultEmblem} alt="클럽 엠블럼"
                     className={emblemImageUrl ? 'emblem' : 'emblem alternate-emblem'}/>
              </div>
            </Tilt>
          }

          <h2 className="name">{name}</h2>
        </ClubSignature>

        <div className="club-notice">
          {isMobile ?
            <Fragment>{clubTopContents}</Fragment>
            :
            <Tilt className="tilt" options={options}>
              {clubTopContents}
            </Tilt>
          }

          {clubNoticeList}
        </div>


      </ClubDetailInfoPopup>
      <ButtonWrap className="full-modal">
        <Button
          primary
          css={PopupBtnStyle}
          onClick={e => {
            e.preventDefault()
            if (onCloseClubDetail) {
              onCloseClubDetail()
            }
            if (onClickMatchup) {
              onClickMatchup(id)
            }
            globalStore.cleanVisibleModalList()
          }}
          className="one-button bottom-btn modal"
        >
          <ClubPortalIco/>
          클럽 방문
        </Button>
      </ButtonWrap>
      <ClubNoticePopup/>
    </Fragment>
  )
}
export default observer(ClubInfoPopup)
